import { intelligentPhotoCaptureConstants } from '../constants';
export const INTELLIGENT_PHOTO_CAPTURE_ESTIMATOR_INVALID_FILE_UPLOAD = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_ESTIMATOR_INVALID_FILE_UPLOAD`;
export const INTELLIGENT_PHOTO_CAPTURE_ESTIMATOR_RESET_INVALID_FILE_UPLOAD = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_ESTIMATOR_RESET_INVALID_FILE_UPLOAD`;
export const photoCaptureIntelligentEstimatorInvalidFileUploadAction = (errorData) => ({
    type: INTELLIGENT_PHOTO_CAPTURE_ESTIMATOR_INVALID_FILE_UPLOAD,
    payload: { errorData }
});
export const photoCaptureIntelligentEstimatorResetInvalidFileUploadAction = () => ({
    type: INTELLIGENT_PHOTO_CAPTURE_ESTIMATOR_RESET_INVALID_FILE_UPLOAD,
    payload: {}
});
//# sourceMappingURL=photoCaptureIntelligentEstimatorInvalidFileUploadAction.js.map